import { Gym } from 'fitbeat.models';
import { UserWorkoutSession } from '../../../entities';
import { Mapper } from '../../serialization/mapper';
import { BaseSerializedWorkoutRepository } from '../base-serialized-workout-repository';

export class JsonWorkoutRepository extends BaseSerializedWorkoutRepository {
  private backend: string = '[]';

  public getAll(gym: Gym): Promise<UserWorkoutSession[]> {
    const arr: UserWorkoutSession[] = JSON.parse(this.backend);
    const filteredByGym = arr.filter((userWorkoutSession: UserWorkoutSession) => {
      return userWorkoutSession.gymName === gym.name;
    });
    Mapper.setupAllAfterDeserialize(filteredByGym);
    return Promise.resolve(filteredByGym);
  }

  public add(userWorkoutSession: UserWorkoutSession): Promise<void> {
    Mapper.makeSerializable(userWorkoutSession);

    const arr: UserWorkoutSession[] = JSON.parse(this.backend);
    arr.push(userWorkoutSession);
    this.backend = JSON.stringify(arr);

    return Promise.resolve();
  }
}
